import {defineStore} from 'pinia'
import {reactive} from 'vue'

const MAX_JOBS_NUMBER = 15;
const TWENTY_FOUR_HOUR = 24 * 60 * 60 * 1000;
const VERSION = 4;

export const useCreatorStudioStore = defineStore('creatorStudio', () => {
    const creatorStudio = reactive({
        jobs: [],
        settings: {},
        isMobile: false,
    })

    function getCreatorStudio() {
        return creatorStudio.jobs;
    }

    function getJobs() {
        return creatorStudio.jobs;
    }

    function addJob(job) {
        creatorStudio.jobs.push(job);

        // Enforce the maximum 25 jobs rule
        if (creatorStudio.jobs.length > MAX_JOBS_NUMBER) {
            creatorStudio.jobs.shift();
        }

        localStorage.setItem('creatorStudioUpdateTime', Date.now());
    }

    function getJobById(id) {
        return creatorStudio.jobs.find(job => job.id === id);
    }

    function getSettings() {
        return creatorStudio.settings;
    }

    function updateSettings(settings) {
        creatorStudio.settings = settings;
    }

    return {
        creatorStudio,
        getCreatorStudio,
        addJob,
        getJobs,
        getJobById,
        getSettings,
        updateSettings,
    }
}, {
    persist: {
        paths: ['creatorStudio'],
        beforeRestore: () => {
            shouldRestoreData();
        },
        afterRestore: (ctx) => {
            ctx.store.creatorStudio.jobs = ctx.store.creatorStudio.jobs.filter(function (obj) {
                return obj.state === 'completed';
            });

            localStorage.setItem('creatorStudioVersion', VERSION)
        }
    },
});

function shouldRestoreData() {
    const storedData = localStorage.getItem('creatorStudio');
    if (!storedData) {
        return false;
    }

    if (parseInt(localStorage.getItem('creatorStudioVersion')) !== VERSION) {
        localStorage.removeItem('creatorStudio');
        return false;
    }

    const lastUpdateTime = localStorage.getItem('creatorStudioUpdateTime');
    if (!lastUpdateTime) {
        localStorage.setItem('creatorStudioUpdateTime', Date.now());
        return false;
    }

    const currentTime = Date.now();
    if (currentTime - lastUpdateTime >= TWENTY_FOUR_HOUR) {
        localStorage.removeItem('creatorStudio');
        localStorage.removeItem('creatorStudioUpdateTime');

        return false;
    }

    return true;
}






